(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcControlFullController', Controller);

    Controller.$inject = ['$rootScope','$scope', '$state', '$mdToast', 'grcControlService'];

    function Controller($rootScope, $scope, $state, $mdToast, grcControlService) {

        // Select Owner
        $scope.selectOwner = function (person) {
            $scope.boxModel.Owner = person;
            $scope.boxModel.OwnerID = person.ItemPersonID;
            $scope.pageIsDirty();
        }

        // Add Owner Delegate
        $scope.addOwnerDelegate = function (ownerDelegate) {
            if (_.isUndefined($scope.boxModel.OwnerDelegates)) $scope.boxModel.OwnerDelegates = [];

            $scope.boxModel.OwnerDelegates.push(ownerDelegate);
            $scope.pageIsDirty();
        }

        // Remove Owner Delegate
        $scope.removeOwnerDelegate = function (ownerDelegate) {
            $scope.boxModel.OwnerDelegates = _.reject($scope.boxModel.OwnerDelegates, { ItemPersonID: ownerDelegate.ItemPersonID });
            $scope.pageIsDirty();
        }

        // On Must Test For External Auditor Change 
        $scope.onMustTestForExternalAuditorChange = function () {

            $scope.pageIsDirty();

            if (!$scope.boxModel.ControlAssessment) return;
            if (!$scope.boxModel.ControlAssessment.IsAssessed) return;

            $mdToast.show(
                   $mdToast
                       .simple()
                       .content('This change will reset the control pre-assessment and review. Test results will however be preserved.')
                       .position('top right')
                       .hideDelay($scope.govNotificationDelay)
                       .action('OK')
                       .theme('danger')
               );
        };

        // Get All Points Of focus
        $scope.allPointsOfFocus = [];
        grcControlService.getAllCosoPointsOfFocus()
            .then(function (allPointsOfFocus) {
                if (allPointsOfFocus instanceof Array) {
                    $scope.allPointsOfFocus = allPointsOfFocus;
                }
            });

        // Get All Financial Statements
        $scope.allFinancialStatements = [];
        grcControlService.getAllFinancialStatements()
            .then(function (appFinancialStatements) {
                if (appFinancialStatements instanceof Array) {
                    $scope.allFinancialStatements = appFinancialStatements;
                }
            });

        // Points of Focus
        if (!$scope.boxModel.CosoPointsOfFocus) {
            $scope.boxModel.CosoPointsOfFocus = [];
        }
        $scope.nbCOSOLinksApplied = '';
        updateNbCOSOLinks();

        // Financial Statements
        if (!$scope.boxModel.FinancialStatements) {
            $scope.boxModel.FinancialStatements = [];
        }
        sortFinancialStatements();

        // Update Point Of Focus
        $scope.updatedPointsOfFocus = function (newPointsOfFocus) {
            var eq = $scope.boxModel.CosoPointsOfFocus.length === newPointsOfFocus.length;

            if (eq && $scope.boxModel.CosoPointsOfFocus.length > 0) {

                eq = _.every($scope.boxModel.CosoPointsOfFocus, function (existingPOF) {
                    return _.some(newPointsOfFocus, { ItemID: existingPOF.ItemID });
                });
            }

            if (!eq) {
                $scope.boxModel.CosoPointsOfFocus = newPointsOfFocus;
                updateNbCOSOLinks();
                $scope.pageIsDirty();
            }
        }

        // Sort Financial Statements Group
        $scope.sortFinancialStatementsGroup = function (groups) {
            var sortedGroups =
                   _.chain(groups)
                    .map(function (group) {
                        group.items = _.reject(group.items, function (financialStatement) {
                            return _.some($scope.boxModel.FinancialStatements, {
                                FinancialStatementID: financialStatement.FinancialStatementID
                            });
                        });

                        return group;
                    })
                    .filter(function (group) {
                        return group.items.length > 0;
                    })
                    .sortBy('name')
                    .value();

            return sortedGroups;
        }

        // Group Financial Statements
        $scope.groupFinancialStatements = function (financialStatement) {
            return financialStatement.Type + ' > ' + financialStatement.Caption;
        }

        // Financial Statements Selection Changed
        $scope.financialStatementsSelectionChanged = function () {
            sortFinancialStatements();
            $scope.pageIsDirty();
        }

        // Show Reset Action?
        $scope.showResetAction = function () {
            if (!$scope.canEdit) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Reset forms
        $scope.reset = function () {
            $scope.isLoading = true;
            $state.reload();
        }

        // Show Close Control?
        $scope.showCloseControl = function () {
            if (!$scope.canEdit) return false;
            if (!$scope.boxModel.ControlID) return false;

            return !$scope.boxModel.IsClosed;
        };

        // Close Control
        $scope.closeControl = function () {
            $scope.isLoading = true;
            grcControlService
                .closeControl($scope.boxModel)
                .then(function (closedControl) {
                    _.assign($scope.boxModel, closedControl);
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

        // Show Save Action
        $scope.showSaveAction = function (form) {
            if (!$scope.canEdit) return false;
            if (!$scope.boxModel.ControlID) return false;
            if (form.$invalid) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        }

        // Show Add Action
        $scope.showAddAction = function (form) {
            if ($scope.boxModel.ControlID) return false;
            if (form.$invalid) return false;

            return $scope.canEdit;
        }

        // Create Or Update
        $scope.createOrUpdate = function () {
            $scope.isLoading = true;
            $scope.boxModel.ItemOrderID = $scope.boxModel.DisplayItemOrderID;

            grcControlService
                .createOrUpdateControl($scope.boxModel)
                .then(function (updatedControl) {

                    if (_.isUndefined($scope.boxModel.ControlID)) {
                        $state.go('control', { ControlID: updatedControl.ControlID, SkipDirtyCheck: true });
                    }
                    else {
                        var previouslyAssessed = $scope.boxModel.ControlAssessment && $scope.boxModel.ControlAssessment.IsAssessed;
                        _.assign($scope.boxModel, updatedControl);
                        if (!_.isUndefined($scope.boxModel.ImplementationDate)) {
                            $scope.boxModel.ImplementationDate = moment($scope.boxModel.ImplementationDate).format();
                        }

                        $mdToast.show(
                            $mdToast
                                .simple()
                                .content('Your changes have been saved!')
                                .position('top right')
                                .hideDelay($scope.govNotificationDelay)
                                .action('OK')
                                .theme('primary')
                        );

                        // Need refresh
                        if (previouslyAssessed) $rootScope.$broadcast('need-refresh');

                        $scope.pageIsNotDirty();
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

        // Helpers

        function updateNbCOSOLinks() {
            var txt;
            if (!$scope.boxModel.CosoPointsOfFocus || $scope.boxModel.CosoPointsOfFocus.length === 0) {
                txt = 'No COSO links';
            } else if ($scope.boxModel.CosoPointsOfFocus.length === 1) {
                txt = '1 COSO link';
            } else {
                txt = $scope.boxModel.CosoPointsOfFocus.length + ' COSO links';
            }
            $scope.nbCOSOLinksApplied = txt;
        }

        function sortFinancialStatements() {
            $scope.boxModel.FinancialStatements = _.sortBy($scope.boxModel.FinancialStatements, function (financialStatement) {
                return financialStatement.Type + financialStatement.Caption + financialStatement.Name;
            });
        }
    }

})();